import moment from "moment";

const useChart = () => {
  const formatDataByPeriod = (data, period, mode) => {
    if (!data) return [];
    switch (period) {
      case "days":
        return data;
      case "weeks":
        return reformatDataIntoWeeks(data, mode);
      case "months":
        return reformatDataIntoMonths(data, mode);
      case "years":
        return reformatDataIntoYears(data, mode);
      default:
        return data;
    }
  };

  function reformatDataIntoYears(data, mode) {
    const result = [];

    const datenProJahr = data.reduce((acc, item) => {
      const jahr = new Date(item.day).getFullYear();
      if (!acc[jahr]) {
        acc[jahr] = { day: `${jahr}`, count: 0 };
      }
      Object.keys(item).forEach((key) => {
        if (key !== "day") {
          acc[jahr][key] = (acc[jahr][key] || 0) + parseInt(item[key], 10);
        }
      });
      acc[jahr]["count"] += 1; // Zähle, wie viele Einträge pro Jahr vorhanden sind
      return acc;
    }, {});

    for (const [_, value] of Object.entries(datenProJahr)) {
      if (mode === "average") {
        Object.keys(value).forEach((key) => {
          if (key !== "day" && key !== "count") {
            value[key] = value[key] / value["count"];
          }
        });
      }
      delete value["count"]; // Entferne den Zähler vor der Rückgabe
      result.push(value);
    }

    return result;
  }

  function reformatDataIntoMonths(data, mode) {
    const result = [];
    const counts = {};

    const datenProMonat = data.reduce((acc, item) => {
      const datum = new Date(item.day);
      const monat = `${datum.getFullYear()}-${datum.getMonth() + 1}`;
      if (!acc[monat]) {
        acc[monat] = {
          day: moment(datum).format("MMMM YYYY"),
        };
        counts[monat] = 0;
      }
      counts[monat] += 1;
      Object.keys(item).forEach((key) => {
        if (key !== "day") {
          acc[monat][key] = (acc[monat][key] || 0) + parseInt(item[key], 10);
        }
      });
      return acc;
    }, {});

    for (const [monat, value] of Object.entries(datenProMonat)) {
      if (mode === "average" && counts[monat] > 0) {
        Object.keys(value).forEach((key) => {
          if (key !== "day") {
            value[key] = value[key] / counts[monat];
          }
        });
      }
      result.push(value);
    }

    return result;
  }

  function reformatDataIntoWeeks(data, mode) {
    const result = [];
    const counts = {};

    const datenProWoche = data.reduce((acc, item) => {
      const woche = `KW ${new Date(item.day).getWeekNumber()}`;
      if (!acc[woche]) {
        acc[woche] = { day: woche };
        counts[woche] = 0;
      }
      counts[woche] += 1;
      Object.keys(item).forEach((key) => {
        if (key !== "day") {
          acc[woche][key] = (acc[woche][key] || 0) + parseInt(item[key], 10);
        }
      });
      return acc;
    }, {});

    for (const [woche, value] of Object.entries(datenProWoche)) {
      if (mode === "average" && counts[woche] > 0) {
        Object.keys(value).forEach((key) => {
          if (key !== "day") {
            value[key] = value[key] / counts[woche];
          }
        });
      }
      result.push(value);
    }

    return result;
  }

  // eslint-disable-next-line no-extend-native
  Date.prototype.getWeekNumber = function () {
    const firstDayOfYear = new Date(this.getFullYear(), 0, 1);
    const pastDaysOfYear = (this - firstDayOfYear) / 86400000;
    return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
  };

  return { formatDataByPeriod };
};

export default useChart;
